import React from 'react';
import { ExternalLink } from 'lucide-react';
import ScreenHeading from '../../utilities/ScreenHeading/ScreenHeading';
import ScrollService from '../../utilities/ScrollService';
import Animations from '../../utilities/Animations';
import minerImg from '../../assets/Blogs/miner.png';
import packageImg from '../../assets/Blogs/packagemanagers.jpg';
import react19Img from '../../assets/Blogs/react19.png';

const blogList = [
  {
    title: 'Mining Bitcoin with a Raspberry Pi',
    image: minerImg,
    tag: 'Hardware',
    description:
      `Can a Raspberry Pi 5 mine Bitcoin? Sure…but at snail speed! This experiment earned 0 BTC but led to a bonus Pong game, drew crowds, sparked great conversations at Waubonsee's STEM event, and showcased the power of creativity. A fun and educational journey proving that even "failed" projects can bring success, laughs, and valuable lessons.`,
    link: 'https://cbolosan.hashnode.dev/mining-bitcoin-raspberry-pi',
  },
  {
    title: 'NPM vs Yarn vs PNPM',
    image: packageImg,
    tag: 'DevTools',
    description:
      "Choosing the right package manager is crucial for your app's development. Whether you're a seasoned developer or just starting out, understanding the functionalities, strengths, and limitations of each is key. In this blog, we'll compare NPM, Yarn, and PNPM to help you determine the best fit for your project needs.",
    link: 'https://cbolosan.hashnode.dev/navigating-the-package-manager-landscape-npm-vs-yarn-vs-pnpm',
  },
  {
    title: "Mastering React 19: What's New",
    image: react19Img,
    tag: 'React',
    description:
      "React 19 is here! The latest version of Meta's beloved JavaScript library is set to shake things up in the web development world. With a big emphasis on speed, developer happiness, and shiny new features, React 19 promises to make building snazzy web apps smoother than ever. Whether you're a seasoned React veteran or someone just getting your feet wet, there's something exciting in here for you.",
    link: 'https://cbolosan.hashnode.dev/mastering-react-19-whats-new-and-why-you-should-care',
  },
];

const BlogCard = ({ blog }) => (
  <div className="bg-gradient-to-br from-slate-900 to-slate-800 text-white rounded-lg shadow-lg flex flex-col h-full overflow-hidden">
    <div className="h-48 overflow-hidden">
      <img
        src={blog.image}
        alt={blog.title}
        className="w-full h-full object-cover"
      />
    </div>
    <div className="p-6 flex flex-col flex-1">
      <span className="px-3 py-1 text-xs rounded-full bg-blue-500/20 text-blue-300 w-fit mb-3">
        {blog.tag}
      </span>
      <h3 className="text-lg font-bold bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent mb-3">
        {blog.title}
      </h3>
      <p className="text-gray-300 text-sm leading-relaxed flex-1 line-clamp-4">
        {blog.description}
      </p>
      <div className="mt-auto pt-4 border-t border-gray-700">
        <a
          href={blog.link}
          target="_blank"
          rel="noreferrer"
          className="flex items-center gap-2 px-4 py-2 rounded-lg bg-blue-500/20 text-blue-300 hover:bg-blue-500/30 transition-colors w-fit"
        >
          <ExternalLink size={16} />
          Read the blog
        </a>
      </div>
    </div>
  </div>
);

export default function Blogs(props) {
  ScrollService.currentScreenFadeIn.subscribe((screen) => {
    if (screen.fadeInScreen !== props.id) return;
    Animations.animations.fadeInScreen(props.id);
  });

  return (
    <div
      className="screen-container fade-in py-16"
      id={props.id || 'Blogs'}
    >
      <div className="max-w-7xl mx-auto px-4">
        <ScreenHeading title={'Blogs'} subHeading={'Journey into Knowledge'} />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">
          {blogList.map((blog) => (
            <BlogCard key={blog.title} blog={blog} />
          ))}
        </div>
      </div>
    </div>
  );
}
